/** @format */
import { Component, Input, OnInit } from '@angular/core';

import { OrderProgress } from '@my-account/data-access/interfaces';

@Component({
	selector: 'my-account-components-progress-tracker',
	templateUrl: './progress-tracker.component.html',
	styleUrls: ['./progress-tracker.component.scss']
})
export class ProgressTrackerComponent implements OnInit {
	@Input()
		groupStatusPosition: string;

	@Input()
		fulfilmentType: string;

	// @Input()
	// progressNodes: number;

	// TODO: Reusable progress component attributes
	// public nodePositions: string[];

	public orderProgress: OrderProgress = {
		firstNodeName: '',
		firstNodeClass: '',
		secondNodeName: '',
		secondNodeClass: '',
		thirdNodeName: '',
		thirdNodeClass: '',
		endNodeName: '',
		endNodeClass: '',
		progressValue: 0,
		nodeLabel: '',
		nodeLabelClass: '',
		activeNode: 0,
		};


	ngOnInit(): void {
		this.setOrderProgress(this.groupStatusToNumber(this.groupStatusPosition), this.fulfilmentType);
	}


	/**
	 * Get total stops along progress bar
	 * @param nodes How many nodes are on the progress bar (including start/end)
	 * @returns array of numbers indicating the positions of the milestones on the progress bar
	 */
	public getNodeSpacing(nodes = 2): string[] {
		// Must have at least two nodes!
		if (nodes < 2) {
			nodes = 2;
		}
		const nodeSpacing = ['milestone-start'];
		const nodeSize = Math.round(100/(nodes - 1));
		let nodesTotal = 0;
		while (nodesTotal < 100) {
			nodesTotal += nodeSize;
			if (nodesTotal < 99) {
				nodeSpacing.push(`milestone-${nodesTotal}`);
			}
		}
		nodeSpacing.push('milestone-end');
		return nodeSpacing;
	}

	// MVP Only - Plan to make these dynamic
	public setOrderProgress(currentStatus, fulfilmentType) {
		switch (currentStatus) {
			case 1: {
				this.orderProgress.firstNodeName = 'sign-check-circle-filled';
				this.orderProgress.firstNodeClass = 'current';
				this.orderProgress.secondNodeName = 'sign-circle';
				this.orderProgress.secondNodeClass = 'upcoming';
				this.orderProgress.thirdNodeName = 'sign-circle';
				this.orderProgress.thirdNodeClass = 'upcoming';
				this.orderProgress.endNodeName = 'sign-circle';
				this.orderProgress.endNodeClass = 'upcoming';
				this.orderProgress.progressValue = 0;
				this.orderProgress.nodeLabel = 'Order placed';
				this.orderProgress.activeNode = 1;
				break;
			}
			case 2: {
				this.orderProgress.firstNodeName = 'sign-circle';
				this.orderProgress.firstNodeClass = 'previous';
				this.orderProgress.secondNodeName = 'sign-check-circle-filled';
				this.orderProgress.secondNodeClass = 'current';
				this.orderProgress.thirdNodeName = 'sign-circle';
				this.orderProgress.thirdNodeClass = 'upcoming';
				this.orderProgress.endNodeName = 'sign-circle';
				this.orderProgress.endNodeClass = 'upcoming';
				this.orderProgress.progressValue = 33;
				if(fulfilmentType === 'shipping') {
					this.orderProgress.nodeLabel = 'Preparing for shipment';
				} else if (fulfilmentType === 'sameday') {
					this.orderProgress.nodeLabel = 'Preparing delivery';
				} else {
					this.orderProgress.nodeLabel = 'In process';
				}
				this.orderProgress.activeNode = 2;
				break;
			}
			case 3: {
				this.orderProgress.firstNodeName = 'sign-circle';
				this.orderProgress.firstNodeClass = 'previous';
				this.orderProgress.secondNodeName = 'sign-circle';
				this.orderProgress.secondNodeClass = 'previous';
				this.orderProgress.thirdNodeName = 'sign-check-circle-filled';
				this.orderProgress.thirdNodeClass = 'current';
				this.orderProgress.endNodeName = 'sign-circle';
				this.orderProgress.endNodeClass = 'upcoming';
				this.orderProgress.progressValue = 66;
				if(fulfilmentType === 'shipping') {
					this.orderProgress.nodeLabel = 'Shipped';
				} else if (fulfilmentType === 'sameday') {
					this.orderProgress.nodeLabel = 'On the way';
				} else {
					this.orderProgress.nodeLabel = 'Ready for pickup';
				}
				this.orderProgress.activeNode = 3;
				break;
			}
			case 4: {
				this.orderProgress.firstNodeName = 'sign-circle';
				this.orderProgress.firstNodeClass = 'previous';
				this.orderProgress.secondNodeName = 'sign-circle';
				this.orderProgress.secondNodeClass = 'previous';
				this.orderProgress.thirdNodeName = 'sign-circle';
				this.orderProgress.thirdNodeClass = 'previous';
				this.orderProgress.endNodeName = 'sign-check-circle-filled';
				this.orderProgress.endNodeClass = 'current';
				this.orderProgress.progressValue = 100;
				if(fulfilmentType === 'shipping') {
					this.orderProgress.nodeLabel = 'Delivered';
				} else if (fulfilmentType === 'sameday') {
					this.orderProgress.nodeLabel = 'Delivered';
				} else {
					this.orderProgress.nodeLabel = 'Picked up';
				}
				this.orderProgress.activeNode = 4;
				break;
			}
		}
	}

	/**
	 * This will need to be expanded for a truly customizable version of this component
	 * @param groupStatus
	 * @returns int for progress tracker. Default to 'In Process'
	 */
	public groupStatusToNumber(groupStatus): number {
		if (groupStatus === 'Order Placed') {
			return 1;
		} else if (groupStatus === 'In Process' || groupStatus === 'Preparing Delivery') {
			return 2;
		} else if (groupStatus === 'Shipped' || groupStatus === 'Ready For Pickup' || groupStatus === 'On the Way') {
			return 3;
		} else if (groupStatus === 'Delivered' || groupStatus === 'Picked Up') {
			return 4;
		} else {
			return 2;
		}
	}

}
